<div
  class="container mx-auto lg:flex-row items-center justify-center w-full py-[1.6rem]"
>
  <!-- USER AGREEMENT -->
  <div class="lg:basis-[50%]">
    <h2 class="text-3xl lg:text-4xl font-bold mb-3">
      USER AGREEMENT AND TERMS OF SERVICE
    </h2>
    <p>
      <span class="font-bold">OnlyUsedTesla.com</span> or, the “Site”, is an
      interactive online service that offers users information services and
      content provided by individual buyers, sellers, and other information
      providers (“hereinafter referred to as the “Service”) through a website,
      mobile and other online applications.
    </p>
    <p>
      In order to protect the interests of all of our users, as well as those of
      our information providers, we ask that you abide by the following rules.
      By registering as a user on the Site or by using the Site in any capacity,
      users hereby agree to be bound by all of the following terms and
      conditions (“Terms of Service” or “TOS”).
    </p>
  </div>
  <!-- GENERAL PROVISIONS -->
  <div class="lg:basis-[50%]">
    <h2 class="text-3xl lg:text-4xl font-bold mb-3">GENERAL PROVISIONS</h2>
    <p>
      By using the Site and Service, you accept the terms of the TOS. This is a
      legally binding agreement between you and the Site. Please read it
      carefully. When using the Site, you may be subject to other posted terms
      and guidelines applicable to certain services available on or through the
      Site.
    </p>
    <p>
      You may be subject to other posted terms and guidelines applicable to
      certain services available on or through the Site. All terms and
      guidelines on the Site, including our Privacy Statement, are part of this
      TOS and incorporated herein by reference. Unless explicitly stated
      otherwise, any features or services available at any time on the Site, are
      subject to this TOS. Accessing the Site in any manner, even through
      automated means, constitutes your use of the Services and your agreement
      to be bound by this TOS. Only Used Tesla may change the terms of the TOS
      from time to time and will revise the effective date when it does so. Your
      continued use of the Site after the posted effective date constitutes your
      agreement to be bound by the TOS as modified, except that modifications do
      not apply to any dispute arising prior to their effective date. Only Used
      Tesla may change, restrict access to, suspend, or discontinue the Site, or
      any portion thereof.
    </p>
    <p>
      The material that appears on the Site is for general informational
      purposes only. While we aim to provide a site that is useful, be mindful
      that the Site may, from time to time, contain errors. The Site includes
      materials and information collected from and provided by third parties
      that we may not have evaluated or reviewed. We make no guarantees
      regarding the accuracy, completeness, timeliness, or reliability of any of
      the materials or information on the Site, and you should not rely on it
      without independent verification.
    </p>
    <p>
      We invite you to bring to our attention any materials or information on
      the Site that you believe to be inaccurate. Please forward a copy of the
      materials or information to us along with an explanation of the
      inaccuracies.
    </p>
  </div>

  <!-- COPYRIGHT NOTICE AND LIMITATIONS ON USE -->
  <div class="lg:basis-[50%]">
    <h2 class="text-3xl lg:text-4xl font-bold mb-3">
      COPYRIGHT NOTICE AND LIMITATIONS ON USE
    </h2>
    <p>
      All of the information, content and services (collectively, the “Content”)
      within this Site are protected by copyright and other intellectual
      property laws. The Content is owned by OnlyUsedTesla and its affiliated
      companies, licensors and suppliers. The Content is provided to users for
      their personal, non-commercial use only. The materials on the Site are the
      property of
      <strong>OnlyUsedTesla.com</strong> or its licensors, and are protected by
      U.S. copyright laws, other copyright laws, and international conventions.
      Except as explicitly provided in these TOS, you may not distribute,
      transmit, display, reproduce, modify, create derivative works from, or
      otherwise exploit any of the materials on the Site. You may display and
      occasionally print a single copy of any page of the Site for your
      personal, non-commercial use, but you may not otherwise reproduce any
      material appearing on the Site without the prior written consent of the
      owner of such materials. You may not store any significant portion of, nor
      distribute copies of, materials found on the Site, in any form (including
      electronic form), without prior written permission from the owner of such
      materials. Requests regarding use of the Content for any purpose other
      than personal, noncommercial use should be directed to
      <a
        class="font-bold underline text-[blue]"
        href="mailto:contact@onlyusedtesla.com"
        >contact&commat;OnlyUsedTesla.com.</a
      >
    </p>
    <p>
      You acknowledge that the Content on the Site includes certain trademarks
      and service marks owned by
      <strong>OnlyUsedTesla</strong> and/or Adam Qureshi, including the name
      “OnlyUsedTesla.com” and certain logotypes, as well as trademarks owned by
      other information providers. You agree not to copy, use or otherwise
      infringe upon these trademarks or service marks. You further agree that
      you will not alter or remove any trademark, copyright or other notice from
      any copies of the Content without the prior written consent of the owner
      of the mark.
    </p>
    <p>
      If you operate a web site and wish to link to the Service, so long as the
      link does not state or imply any endorsement or sponsorship of you, your
      company, or your website by Only Used Tesla or any of our Partners.
      However, without our prior written permission, you may not frame any of
      the content of the Site, nor incorporate into another website or service
      any intellectual property of Only Used Tesla or its licensors.
    </p>
    <p>
      Associated Press (“AP”) text, photo, graphic, audio and/or video material
      shall not be published, broadcast, rewritten for broadcast or publication
      or redistributed directly or indirectly in any medium. Neither these AP
      materials nor any portion thereof may be stored in a computer except for
      personal and non-commercial use. AP will not be held liable in any way to
      the User or to any third party or to any other person who may receive
      information in the Service or to any other person whatsoever, for any
      delays, inaccuracies, errors or omissions therefrom or in the transmission
      or delivery of all or any part thereof or for any damages arising from any
      of the foregoing or occasioned thereby.
    </p>

    <!-- Ownership and Permissions of Material on the Site -->
    <div class="lg:basis-[50%]">
      <h2 class="text-2xl lg:text-2xl font-bold mb-3">
        Ownership and Permissions of Material on the Site
      </h2>
      <p>
        By placing material on or communicating with the Site and the Service,
        you hereby grant to the Site and its partners and their affiliates and
        related entities (collectively, “the Partners”) the royalty-free,
        perpetual, irrevocable, nonexclusive right and license to use, copy,
        modify, display, distribute and reproduce all such materials in any
        form, media, software or technology of any kind now existing or
        developed in the future. The foregoing license includes the right to
        exploit any proprietary rights in such material, including, but not
        limited to, rights under copyright, trademark, or patent laws that exist
        in any applicable jurisdiction. You will not receive any compensation of
        any kind for the use of any material you transmit or post via the Only
        Used Tesla Site. Among other uses of user materials, the Only Used Tesla
        Site uses listings data to derive useful information (such as vehicle
        valuation information) for display, sale and distribution. You also
        agree to indemnify, defend and hold the Site and the Partners harmless
        against any claims or costs, including attorneys’ fees, arising from the
        use or distribution of those materials. You further grant the Site and
        the Partners the right to use your name in connection with the
        reproduction or distribution of such material.
      </p>
    </div>

    <!-- Interactive Areas.  -->
    <div class="lg:basis-[50%]">
      <h2 class="text-2xl lg:text-2xl font-bold mb-3">Interactive Areas.</h2>
      <p>
        The Site allow users to publish listings, ratings, and reviews and to
        access social media tools where users may post material accessible to
        others or transmit communications to others. Some of these tools may be
        operated by third parties, and your use of them is subject to both the
        terms of this TOS and to the policies of their third-party providers.
        You assume total responsibility and risk for your use of any interactive
        areas of the Only Used Tesla Site. You acknowledge that any of the
        user-generated content posted or transmitted through the Site represents
        the views of the author, and not of Only Used Tesla. You also
        acknowledge that your use of or reliance on such content is at your own
        risk.
      </p>
      <p>
        <a
          class="font-bold underline text-[blue]"
          href="https://www.onlyusedtesla.com"
          >OnlyUsedTesla.com </a
        >, does not endorse the accuracy or reliability of any advice, opinion,
        statement or information posted on these forums, message boards,
        bulletin boards or chat rooms. Please use your best judgment, and be
        respectful of other individuals using these forums.
      </p>

      <h2 class="text-xl lg:text-xl font-bold mb-3">
        Prohibited Activities and Content
      </h2>
      <p>
        The following is a partial list of the kinds of activities and content
        that are prohibited on or through the Site:
      </p>
      <ol class="list-decimal pl-5">
        <li>Posting or transmitting any material:</li>
        <ul class="list-decimal pl-5">
          <li>
            That is subject to a copyright unless you own or control the
            copyright in and to such material;
          </li>
          <li>
            That violates or infringes the rights of any other party, including,
            without limitation, rights of privacy, rights of publicity,
            copyright, trademark, or other intellectual property rights;
          </li>
          <li>
            That is knowingly false and/or misleading, defamatory, inaccurate,
            libelous, promotes illegal activities or tortuous or in violation of
            any applicable law, rule, or regulation;
          </li>
          <li>
            Patently offensive to the online community including abusive,
            vulgar, hateful, racist, bigoted, sexist, harassing, threatening,
            inflammatory, obscene, profane, sexually oriented,
          </li>
          <li>
            That is invasive of a person’s privacy (e.g., containing phone
            numbers, addresses, or other personal information);
          </li>
          <li>
            Engaging in activities or submitting content that could be harmful
            to minors;
          </li>
        </ul>

        <ul class="list-decimal pl-5">
          <li>
            Engaging activity or submitting content that harasses or advocates
            harassment of another person;
          </li>
          <li>
            Engaging in the gathering and collection of any material from the
            Site and activity that involves the transmission of “junk mail” or
            unsolicited mass mailing or “spam”;
          </li>
          <li>
            Obtaining personal information of Buyers and Sellers who have used
            the Site for the purpose of solicitation;
          </li>
          <li>
            Submitting content that contains restricted or password only access
            pages, or hidden pages or images;
          </li>
          <li>
            Submitting content that displays pornographic or sexually explicit
            material of any kind;
          </li>
          <li>
            Submitting content that provides instructional information about
            illegal activities such as making or buying illegal weapons,
            violating someone’s privacy, or providing or creating computer
            viruses;
          </li>
          <li>
            Engaging in activities or submitting content that solicit passwords
            or personally identifiable information for commercial or unlawful
            purposes from other users; and
          </li>
          <li>
            Engaging in commercial activities and/or sales without our prior
            written consent such as advertisements, commercial solicitations,
            contests, sweepstakes, barter, advertising, and pyramid schemes.
          </li>
        </ul>
      </ol>
      <p>
        You further agree that you will not attempt or do any of the following:
      </p>
      <ol class="list-decimal pl-5">
        <li>
          Interfere with or disrupt the Site or our computer systems, servers,
          or networks;
        </li>
        <li>
          Attempt to gain unauthorized access to any part of the Site, to
          accounts that belong to other users, or to computer systems or
          networks connected to the Site;
        </li>
        <li>
          Engage in any systematic extraction of data or data fields, including,
          without limitation, email addresses, by use of any automated
          mechanism, such web robots, crawlers, or spiders (except in strict
          conformance with the
          <a
            class="font-bold underline text-[blue]"
            href="https://onlyusedtesla.com/robots.txt"
            >Robots Exclusion Protocol</a
          >
          ) or otherwise;
        </li>
        <li>Collect information about others without their consent;</li>
        <li>
          Interfere with the use of the Site by any other individual or party;
        </li>
        <li>
          Impersonate any person, or otherwise attempt to mislead others about
          your identity, or post material under secondary user names or other
          aliases; or
        </li>
        <li>
          Share any user name and/or password you have on the with any other
          persons
        </li>
        <li>
          Take any action that imposes an unreasonable or disproportionately
          large load on
          <a
            class="font-bold underline text-[blue]"
            href="https://www.onlyusedtesla.com"
            >OnlyUsedTesla.com</a
          >’s hardware and software infrastructure.
        </li>
      </ol>
      <p>
        Without limiting any of or Adam other rights or remedies, a violation of
        any of the prohibited activities listed above may result in the removal
        of any content you have transmitted or posted, revocation of any
        accounts you have on the Site or on our affiliated webSite and services,
        and/or a ban from creating new accounts.
      </p>
      <p>
        Given the nature of the Service and the volume of messages and postings,
        The Site cannot and does not consistently monitor all of the material
        posted or transmitted by users and third-party information providers.
        While you agree that the Site will not be liable for such third-party
        content, the Site reserves the right to delete, move or edit any
        communications or content that it deems in its sole discretion to be
        violative of the TOS; harmful to individuals or communities; obscene;
        defamatory; in violation of the Site’s or any third-party’s rights; or
        otherwise unacceptable. We retain the right to deny access to anyone who
        we believe has violated these terms or any other term of the TOS.
      </p>
      <p class="font-bold">
        Notwithstanding the foregoing, Only Used Tesla takes no responsibility
        and assumes no liability for any content posted to the Only Used Tesla
        Site by you or by third parties.
      </p>
      <p>
        <a
          href="https://www.onlyusedtesla.com"
          class="font-bold underline text-[blue]"
          >OnlyUsedTesla.com</a
        >
        does not accept unsolicited materials or ideas for use or publication in
        its programming or in other digital, electronic or print media except in
        connection with the forums, chat rooms and bulletin boards on the
        Service.
        <a
          href="https://www.onlyusedtesla.com"
          class="font-bold underline text-[blue]"
          >OnlyUsedTesla.com</a
        >
        shall not be responsible for the similarity of any of its content or
        programming in any media to materials or ideas transmitted to the
        Service.
      </p>

      <h2 class="text-xl lg:text-xl font-bold mb-3">Termination of Service.</h2>
      <p>
        Users understand and agree that in the Site’s sole discretion, and
        without prior notice, we may terminate your access to the Site or
        exercise any other remedy available and remove any unauthorized user
        content, if your use of the Site, Service and/or any user content you
        provided:
      </p>
      <ol class="list-decimal list-inside">
        <li>
          Has violated or is inconsistent with these TOS or other incorporated
          terms or guidelines;
        </li>
        <li>
          Has violated the rights of
          <a
            class="font-bold underline text-[blue]"
            href="https://www.onlyusedtesla.com"
            >OnlyUsedTesla.com</a
          >, another user;
        </li>
        <li>
          Has violated any law or otherwise constitutes fraud, illegal or
          unethical activity;
        </li>
        <li>
          Results in a request be law enforcement or other governmental or
          regulatory agency to terminate your use.
        </li>
      </ol>
      <p>
        All terminations will be made in our sole discretion and you agree that
        we will not be liable for any termination of your use of or access to
        the Site or any part of the Site. You agree that monetary damages may
        not provide a sufficient remedy to the Site for violations of these TOS
        and you consent to injunctive or other equitable relief for such
        violations.
        <a
          class="font-bold underline text-[blue]"
          href="https://www.onlyusedtesla.com"
          >OnlyUsedTesla.com</a
        >
        <span class="font-bold"
          >is not required to provide any refund to you if you are terminated as
          a User because you have violated these TOS.</span
        >.
      </p>
    </div>
  </div>

  <!-- INFORMATION FOR BUYERS AND SELLERS -->
  <div class="lg:basis-[50%]">
    <h2 class="text-3xl lg:text-4xl font-bold mb-3">
      INFORMATION FOR BUYERS AND SELLERS
    </h2>
    <p>
      OnlyUsedTesla.com is a vehicle listing and information service that
      connects buyers and sellers of used Tesla vehicles.
    </p>
    <p>
      OnlyUsedTesla.com is not a party to any transaction that occurs through
      the Site or that originates from information found on the Site.
      OnlyUsedTesla.com is not an automobile broker or dealer and does not sell,
      exchange, buy, or offer for sale, negotiate or attempt to negotiate, a
      sale or exchange of an interest in any vehicle listed for sale on our
      site.
    </p>
    <p>
      OnlyUsedTesla.com does not hold or possess title for any vehicle listed
      for sale on our site.
    </p>
    <p>
      All buyers and sellers must be at least 18 years old to use the site and
      by using the Site, represent that they are at least 18 years old.
    </p>

    <!-- Buyers -->
    <div class="lg:basis-[50%]">
      <h2 class="text-2xl lg:text-2xl font-bold mb-3">Buyers</h2>
      <p>
        The information on vehicles provided on this Site is supplied by the
        seller or third parties, and not the Site. Any information contained on
        the Site is provided on an “as is,” “as available” basis. As such,
        OnlyUsedTesla.com
        <span class="font-bold"
          >CANNOT AND DOES NOT, MAKE, TO ANY ACTUAL OR PROSPECTIVE PURCHASER OR
          OWNER OF ANY VEHICLE, GUARANTEES, WARRANTIES OR REPRESENTATIONS,
          EXPRESS OR IMPLIED</span
        >
        regarding:
      </p>
      <ol class="list-decimal list-inside">
        <li>
          the accuracy or completeness of any information provided on the Site,
        </li>
        <li>the existence or ownership of any vehicle listed on this Site,</li>
        <li>the condition or performance of any vehicles on the Site,</li>
        <li>
          any other information pertaining to any vehicle contained on the Site.
        </li>
      </ol>
      <p>
        Prices reflected on the Site do not include additional fees such as
        government fees and taxes, title and registration fees, licensing and
        plate fees, finance charges, dealer document preparation fees, and
        emission testing. Before purchasing a vehicle, Buyers should confirm
        with the Seller any information, including the price.
      </p>
      <p>
        OnlyUsedTesla.com does not own, hold or possess title, inspect, buy, or
        sell, any vehicles listed for sale on our site. Any dispute about the
        condition of a vehicle sold through the site is between the buyer and
        seller only. Buyers are solely responsible for reading the full vehicle
        listing before making a commitment to buy. Any reliance upon any
        information posted on the Site shall be at Buyer’s sole risk.
      </p>
      <p>
        <a
          class="font-bold underline text-[blue]"
          href="https://www.onlyusedtesla.com"
          >OnlyUsedTesla.com</a
        >
        reserves the right, in its sole discretion, to correct any error or
        omission in any portion of the Site. Any and all concerns, differences
        or discrepancies must be addressed with the seller prior to the sale of
        the vehicle. Buyers agree to release, hold harmless and indemnify
        <a
          class="font-bold underline text-[blue]"
          href="https://www.onlyusedtesla.com"
          >OnlyUsedTesla.com</a
        >
        from any and all liability arising from incorrect or incomplete
        information regarding any vehicle.
      </p>

      <h2 class="text-2xl lg:text-2xl font-bold mb-3">
        All Vehicles Are Subject To Prior Sales.
      </h2>
      <p>
        Buyers are encouraged to read the section on fraud awareness (<span
          class="font-bold"
          >INSERT LINK TO FRAUD AWARENESS SECTION</span
        >) before buying a vehicle listed on the Site.
      </p>

      <h2 class="text-2xl lg:text-2xl font-bold mb-3">Sellers</h2>
      <p>
        Sellers of vehicles represent and warrant and agree to the following:
      </p>
      <ol class="list-decimal list-inside">
        <li>
          By offering a vehicle for sale through the Site you agree to the TOS;
        </li>
        <li>
          That all information submitted to OnlyUsedTesla.com about a particular
          vehicle and their contact information is accurate and true;
        </li>
        <li>
          To approve listing descriptions as complete and accurate before
          publication;
        </li>
        <li>
          That all relevant vehicle information is included in the listing
          submission;
        </li>
        <li>
          They are prepared to sell the listed vehicle at the price at which it
          is listed, and
        </li>
        <li>
          They have possession of the actual vehicle listed and the proper
          authority to transfer title.
        </li>
      </ol>
      <p>
        Sellers acknowledge, understand and accept that they may be asked to
        provide proof of ownership of their vehicles prior to or at any time
        after a vehicle is listed on OnlyUsedTesla.com.
      </p>
      <p>
        The information must accurately identify the seller and the method of
        contact must permit buyers to communicate directly with the seller. You
        may not charge any potential buyer for information about any vehicle
        listed for sale on the Site, nor may you use the to promote, without our
        prior written permission, any other website, product, or service.
      </p>
      <p>
        Sellers agree to provide such information promptly when requested and
        understand that failure to provide such information entitles
        OnlyUsedTesla.com, in its sole discretion, to remove the Seller’s
        listing without a return of any listing fees paid by the Seller.
      </p>
      <p>
        Responsibility for the information contained in each listing lies with
        each seller. You alone are responsible for the material you post,
        including listing information and photos of your vehicle, and for the
        content of all email messages you transmit through the Only Used Tesla
        Site.
      </p>
      <p>
        Sellers of vehicles listed on OnlyUsedTesla.com acknowledge that they
        understand that listing their vehicle with OnlyUsedTesla.com does not
        guarantee a sale and that any Tesla listed with OnlyUsedTesla.com that
        does not result in a sale or that is sold through other means, does not
        and will not, entitle the Seller to a refund of any amounts paid to
        OnlyUsedTesla.com.
      </p>
      <p>
        Sellers acknowledge that OnlyUsedTesla.com that in the event that
        OnlyUsedTesla.com is forced to incur additional fees or charges related
        to the processing or listing of the Seller’s vehicle, Sellers may be
        liable for the payment of those additional amounts above and beyond any
        listing fees paid.
      </p>
    </div>
  </div>

  <!-- GENERAL DISCLAIMER AND LIMITATION OF LIABILITY AND INDEMNIFICATION. -->
  <div class="lg:basis-[50%]">
    <h2 class="text-3xl lg:text-4xl font-bold mb-3">
      GENERAL DISCLAIMER AND LIMITATION OF LIABILITY AND INDEMNIFICATION.
    </h2>
    <p>
      <span class="font-bold">Warranty Disclaimer</span>
    </p>
    <p>
      ONLYUSEDTESLA.COM, INC. MAKES NO CONDITION, REPRESENTATION OR WARRANTY OF
      ANY KIND REGARDING THE SUITABILITY OF THE SITEITES CONTENT, OR ANY PORTION
      THEREOF, FOR ANY PURPOSE. THE SITEITES, ALL SITEITE CONTENT, AND ALL OTHER
      CONTENT AVAILABLE ON OR THROUGH THE SITEITES ARE PROVIDED ON AN “AS IS,”
      “AS AVAILABLE” BASIS, AND ONLYUSEDTESLA.COM, INC. EXPRESSLY DISCLAIMS ANY
      AND ALL CONDITIONS, REPRESENTATIONS AND WARRANTIES OF MERCHANTABILITY OR
      FITNESS FOR PARTICULAR USE, INCLUDING ALL IMPLIED WARRANTIES IN CONNECTION
      WITH THE FOREGOING. ONLYUSEDTESLA.COM, INC. ALSO EXPRESSLY DISCLAIMS ANY
      CONDITION, WARRANTY OR REPRESENTATION AS TO THE ACCURACY, RESULTS,
      TIMELINESS, COMPLETENESS, NON-INFRINGEMENT, OR PROPRIETARY CHARACTER OF
      THE SITEITES, ALL SITEITES CONTENT, AND ALL OTHER CONTENT AVAILABLE ON OR
      THROUGH THE SITEITES. ONLYUSEDTESLA.COM DOES NOT GUARANTEE THAT THE
      SITEITES WILL BE ERROR FREE, OR CONTINUOUSLY AVAILABLE, OR THAT THE
      SITEITES WILL BE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. YOU WAIVE
      AND COVENANT NOT TO ASSERT ANY CLAIMS OR ALLEGATIONS OF ANY NATURE
      WHATSOEVER ARISING FROM OR RELATING TO YOUR USE OF THE SITEITES,
      INCLUDING, WITHOUT LIMITATION, ALL CLAIMS AND ALLEGATIONS RELATING TO THE
      ALLEGED INFRINGEMENT OF PROPRIETARY RIGHTS, THE ALLEGED INACCURACY OF
      SITEITES CONTENT, YOUR INABILITY TO ACCESS THE SITEITES AT ANY GIVEN TIME,
      OR ALLEGATIONS THAT ONLYUSEDTESLA.COM, INC. HAS OR SHOULD INDEMNIFY,
      DEFEND, OR HOLD YOU HARMLESS FROM ANY CLAIM OR ALLEGATION ARISING FROM
      YOUR USE OR OTHER EXPLOITATION OF THE SITEITES
    </p>
    <p>
      <span class="font-bold">Limitation of Liability</span>
    </p>
    <p>
      PARTIES USING THE SITEITES DO SO AT THEIR OWN RISK AND ONLYUSEDTESLA.COM,
      INC., SHALL BE NOT BE LIABLE FOR ANY DAMAGES OF ANY SORT ARISING FROM THE
      USE OF OR INABILITY TO USE THE SITEITESOR ANY PRODUCT OR SERVICE LINKED TO
      OR FROM OR ADVERTISED OR PROMOTED ON THE SITEITES, INCLUDING, WITHOUT
      LIMITATION, CONSEQUENTIAL, SPECIAL, INCIDENTAL, INDIRECT, PUNITIVE,
      EXEMPLARY, OR OTHER DAMAGES OF ANY KIND (INCLUDING LOST REVENUES OR
      PROFITS, LOSS OF BUSINESS, AND LOSS OF DATA), EVEN IF WE ARE ADVISED
      BEFOREHAND OF THE POSSIBILITY OF SUCH DAMAGES. BECAUSE SOME
      STATES/JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY
      FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, THE ABOVE LIMITATIONS MAY NOT
      APPLY TO YOU. TO THE EXTENT PERMITTED BY LAW, ONLYUSEDTESLA.COM ALSO
      DISCLAIMS LIABILITY FOR ANY DIRECT DAMAGES BASED ON YOUR ACCESS OR USE OF
      THE SITEITES AND THE SITEITECONTENT. IF ONLYUSEDTESLA.COM IS FOUND TO BE
      LIABLE UNDER THIS AGREEMENT, INCLUDING FOR DIRECT OR ANY TYPE OF DAMAGES,
      OUR AGGREGATE LIABILITY TO YOU OR TO ANY THIRD PARTY IS LIMITED TO THE
      GREATER OF (A) THE AMOUNT OF FEES PAID BY YOU IN THE 12 MONTHS PRIOR TO
      THE ACTION GIVING RISE TO THE LIABILITY; OR (B) $100.
    </p>
    <p>
      USERS TO INDEMNIFY ONLYUSEDTESLA.COM AND ITS OWNERS, SHAREHOLDERS,
      SUBSIDIARIES, AFFILIATES, OFFICERS, EMPLOYEES, PARTNERS, AND LICENSORS,
      AND THEIR RESPECTIVE SUCCESSORS AND ASSIGNS, AND HOLD ALL OF THE FOREGOING
      HARMLESS, FROM AND AGAINST ANY AND ALL CLAIMS, LIABILITY AND EXPENSES,
      INCLUDING ATTORNEYS’ FEES, ARISING FROM OR RELATED IN ANY WAY TO YOUR USE
      OF THE SITEITES OR ANY BREACH OF THESE TERMS AND CONDITIONS.
    </p>
  </div>

  <!-- DISPUTE RESOLUTION – MANDATORY ARBITRATION AND CLASS ACTION WAIVER -->
  <div class="lg:basis-[50%]">
    <h2 class="text-3xl lg:text-4xl font-bold mb-3">
      DISPUTE RESOLUTION – MANDATORY ARBITRATION AND CLASS ACTION WAIVER
    </h2>
    <p class="font-bold">Arbitration Agreement</p>
    <p>
      You and the Site agree that any claims or disputes (“claims”) that arise
      out of or relate in any way to the terms of the TOS, the Site, or any
      service (including but not limited to billing disputes) shall be resolved
      by final and binding arbitration or in small claims court. In arbitration,
      there is no judge and no jury. Instead, claims are decided by an
      arbitrator whose authority is created by and governed by this arbitration
      agreement. Judicial review of arbitration awards is very limited.
    </p>
    <p class="font-bold">Governing Law & Arbitration Venue</p>
    <p>
      These Terms of Service and any disputes arising from or related to your
      use of the Site, including privacy-related claims, shall be governed by
      the laws of the State of New York, without regard to its conflict of laws
      principles. Any claim or dispute arising out of or relating to these Terms
      or your use of our services will be resolved exclusively through binding
      arbitration conducted in New York State. Arbitration shall be administered
      by the American Arbitration Association (AAA) under its Commercial
      Arbitration Rules and the Supplementary Procedures for Consumer-Related
      Disputes. You expressly waive any right to initiate or participate in
      arbitration or litigation in any other jurisdiction. Arbitration will take
      place at a mutually convenient location within Suffolk County, New York,
      or via remote videoconferencing if mutually agreed by the parties. The
      arbitrator's decision shall be final and binding, and judgment may be
      entered in any court of competent jurisdiction within New York State.
    </p>
    <p class="font-bold">Class Action Waiver</p>
    <p>
      You and the Site agree that all claims between us will be resolved in an
      individual arbitration. Both parties agree that there will be no class,
      representative, or consolidated actions in arbitration. In addition,
      neither you nor the Site may participate in a class or representative
      action in court as a class member if the claims asserted in the litigation
      would fall within the scope of this arbitration agreement if asserted
      directly by you or the Site. You and the Site both waive any right to
      participate in any class action involving disputes between us. This class
      action waiver is an essential part of our arbitration agreement and may
      not be severed. If for any reason this class action waiver is found
      unenforceable, then the entire arbitration agreement will not apply.
      However, the Jury Trial Waiver set forth in this TOS will remain in full
      force and effect.
    </p>
    <p class="font-bold">Arbitrator Authority</p>
    <p>
      The arbitrator’s authority is governed by this arbitration agreement. You
      and the Site agree that the arbitrator may award the same relief that a
      court of competent jurisdiction could award – consistent with and limited
      by the TOS, but the arbitrator may not award declaratory or injunctive
      relief that extends beyond you and your dealings with the Site. An
      arbitrator may award attorneys’ fees and costs to the prevailing party if
      a court would be authorized to do so under the applicable law.
    </p>
    <!-- <p class="font-bold">Arbitrator Authority</p>
        <p>
          The arbitrator’s authority is governed by this arbitration agreement.
          You and the Site agree that the arbitrator may award the same relief
          that a court of competent jurisdiction could award – consistent with
          and limited by the TOS, but the arbitrator may not award declaratory
          or injunctive relief that extends beyond you and your dealings with
          the Site. An arbitrator may award attorneys’ fees and costs to the
          prevailing party if a court would be authorized to do so under the
          applicable law.
        </p> -->
    <p class="font-bold">Arbitration Procedures</p>
    <p>
      You and the Site agree that your agreement affects interstate commerce,
      and the Federal Arbitration Act applies. All arbitrations shall be
      conducted by the American Arbitration Association (AAA) under its
      Commercial Arbitration Rules and the Supplementary Procedures for
      Consumer-Related Disputes. These rules are available at
      <a class="underline text-blue" href="https://www.adr.org/"
        >https://www.adr.org/</a
      >
      If there is a conflict between the AAA Rules and this arbitration
      agreement, then this arbitration agreement shall control. You will be
      responsible for paying your own attorneys’ fees (if you choose to use an
      attorney in arbitration) unless you prevail and the arbitrator finds that
      you are entitled to recover your fees under the law.
    </p>
    <p class="font-bold">Survival</p>
    <p>
      This arbitration agreement survives the termination of this Terms of
      Service between you and the Site.
    </p>
    <p class="font-bold">Jury Trial Waiver</p>
    <p>
      You and the Site expressly and knowingly WAIVE THE RIGHT TO TRIAL BY JURY.
      This means that if for any reason the arbitration agreement contained in
      this TOS is not enforced or is found inapplicable, our claims against each
      other will be resolved by a judge rather than a jury.
    </p>
    <p class="font-bold">Miscellaneous</p>
    <p>
      The Site reserves the right at its discretion to change these TOS and will
      notify users of any such changes by online postings. Your continued use of
      the Service after the posting of any amended TOS shall constitute your
      agreement to be bound by any such changes. The Service may modify,
      suspend, discontinue or restrict the use of any portion of the Service,
      including the availability of any portion of the Content at any time,
      without notice or liability.
    </p>
  </div>

  <h1 class="font-bold">
    IF YOU DO NOT AGREE TO THE TERMS STATED ABOVE OR TO ANY CHANGES THE SERVICE
    MAKES IN THESE TERMS, PLEASE EXIT THE SERVICE IMMEDIATELY.
  </h1>
</div>
